const namespace = "mariApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Medical Application Request Internal",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/mari",
  defaultRoute: "Home",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "med-app-req-parent" */ "@/apps/mari/Application.vue"),
  navigation : [],
  settings: {
    navigation: [{
      text: "Home",
      link: `/mari/Home`,
      icon: "mdi-home",
    },
    {
      text: "Users",
      link: `/mari/MarUser`,
      icon: "mdi-account-multiple",
    },
    {
      icon: "mdi-cog",
      text: "Master Data",
      link: "",
      items: [ 
        {
          icon: "mdi-check-decagram",
          text: "Approver",
          link: "/mari/MasterData/Approver",        
        },
        {
          icon: "mdi-all-inclusive",
          text: "General",
          link: "/mari/MasterData/General",        
        },
        {
          icon: "mdi-format-list-bulleted-type",
          text: "Classification",
          link: "/mari/MasterData/Classification",        
        },
        {
          icon: "mdi-file-sign",
          text: "Contract",
          link: "/mari/MasterData/Contract",
        },        
        {
          icon: "mdi-devices",
          text: "Device Type",
          link: "/mari/MasterData/DeviceType",
        },         
        {
          icon: "mdi-cube",
          text: "Product",
          link: "/mari/MasterData/Product",
        },            
        {
          icon: "mdi-routes",
          text: "Route of Administration",
          link: "/mari/MasterData/RouteOfAdministration",
        },      
      ],
    },
    {
      icon: "mdi-home-analytics",
      text: "Report",
      link: "",
      items: 
      [ 
        {
          icon: "mdi-file-chart-outline",
          text: "Request Info",
          link: "/mari/Report/RequestInfo",
        },
      ],
    },
    // {
    //   text: "Help",
    //   link: "help",
    //   icon: "mdi-help-circle",
    // },
    // {
    //   text: "Config",
    //   link: "config",
    //   icon: "mdi-hammer-wrench",
    // },
  ],
    userRoles:{
      marAdmin: 35,
      marMFP: 36,
      marApprover: 37,
      marReadOnly: 38,
    },

    approvalStatus:{
      pending: 58,
      approved: 59,
      rejected: 60,
      sentBackToUser: 61,
    },

    approverType: {
       ARC: 53,
       BusinessDirector: 54,
       MarketingManager: 55,
       MedicalFocalPoint: 56,
       ProductSteward: 57,
    },

    region: {
      AsiaPacific: 28,
      Australia: 29,
      Europe: 30,
      NA: 31,
      LATAM: 32,
      Global: 33,
    },

    naExceptionProductType: {
      APSEngineeredPlastics: 9,
      APSGelcoat: 10,
      PE: 20,
      PP: 21,
      SpecialtyAndPurellNA: 23,
    },

    environment : "DEV",
    scope: "api://e0891e86-0c9d-4e38-9c61-df8ddef771b2/Read.All",
    clientId: "e0891e86-0c9d-4e38-9c61-df8ddef771b2",
    // scope: "api://a75bb62e-c676-4bd6-aa7b-da69c2ea109b/Read.All",
    // clientId: "a75bb62e-c676-4bd6-aa7b-da69c2ea109b",
    // scope: "api://0a00d2f5-2545-4cc9-9691-681cff842c47/Read.All",
    // clientId: "0a00d2f5-2545-4cc9-9691-681cff842c47",

    apiUrl: "https://localhost:44358/api",
    odataUrl: "https://localhost:44358/odata",
    // apiUrl: "https://as-medappreq-api-dev.azurewebsites.net/api",
    // odataUrl: "https://as-medappreq-api-dev.azurewebsites.net/odata",
    //apiUrl: "https://as-medappreq-api-dev.azurewebsites.net/api",
    authorizeUrl:  
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",
    tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 }, 
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: true,
    //env_color:'"primary"', //PROD    
  },

  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "Medical Application Request Internal",
      storageMode: localStorage,
    },
    userDetails: {
      default: {},
      storageMode: sessionStorage,
    },
    currentUserRoleId: {
      default: {},
      storageMode: sessionStorage,
    },
  },

}

export default AppConfig.merge(appConfig);


